const boundaryConfig = {
  jsonPath: "",
  setResponseData: true,
  hierarchyType: "REVENUE",
  style: {},
  isDisabled: false,
  isRequired: false,
  requiredErrMsg: "",
  patternErrMsg: "",
};

export default boundaryConfig;



// WEBPACK FOOTER //
// src/modules/employee/reports/commons/config.js